export class ThemesModel{
        legalEntityId:any;
        legalEntityGUID : any;
        primaryColor : any;
        secondaryColor : any;
        font:any;
}